import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const MarkNoteUnreadSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default MarkNoteUnreadSVG;
